import {
  DEV_OPENSEA_WALLET_URL,
  LOCAL_OPENSEA_WALLET_URL,
  PROD_OPENSEA_WALLET_URL,
} from "@opensea/embedded-wallet-sdk"
import type { CreateConnectorFn } from "wagmi"
import { embeddedWalletConnector } from "./embeddedWalletConnector"

// Embedded wallet connector custom configuration
export type Environment = "production" | "development" | "local"

function getWalletUrl({
  environment,
  clientId,
}: {
  environment?: Environment
  clientId?: string
} = {}): string {
  function withClientIdQueryParam(url: string) {
    return clientId ? `${url}?clientId=${clientId}` : url
  }
  if (environment === "production") {
    return withClientIdQueryParam(PROD_OPENSEA_WALLET_URL)
  }
  if (environment === "local") {
    return withClientIdQueryParam(LOCAL_OPENSEA_WALLET_URL)
  }
  return withClientIdQueryParam(DEV_OPENSEA_WALLET_URL)
}

type OSEmbeddedWalletConnectorOptions = {
  clientId?: string
  debug?: boolean
  environment?: Environment
}

export function osEmbeddedWalletConnector({
  clientId,
  debug,
  environment,
}: OSEmbeddedWalletConnectorOptions): CreateConnectorFn {
  return embeddedWalletConnector({
    url: getWalletUrl({ clientId, environment }),
    debug,
  })
}
